import "./FilterApplied.css";
import { X } from "lucide-react";

const FilterApplied = ({ filter, removeFilter, ...props }) => {
  if (!filter) {
    return null;
  }

  return (
    <div className="filter-applied">
      <span>{filter}</span>
      <button onClick={removeFilter} className="inline-flex ml-1! outline-none! hover:text-red-400! duration-200! cursor-pointer!">
        <X size={17} />
      </button>
    </div>
  );
};

export default FilterApplied;
